import React from 'react';
import { FcDocument } from "react-icons/fc";
import AboutUs from '../About us/AboutUs';
const Services = () => {
    return (
        <div>
            
            <div className='grid lg:grid-cols-2 grid-cols-1 my-36'>
                <div className='text-left text-xl mx-10 h-screen'>
                <h1 className='text-4xl flex justify-center my-10'> Services We Provide <FcDocument/></h1>
                <li>Background checked and proficient specialists at your doorstep.</li>
                <li>Fast arrangement and on-request service any time.</li>
                <li>Helpful assistance conveyance and bother free experience.</li>
                <li>Legitimate quality upkeep and dependability.</li>
                <li>Proper justification of work and material to diminish over cost</li>
                </div>
            <div className="carousel w-full h-96">
  <div id="slide1" className="carousel-item relative w-full">
    <img src="https://i.ibb.co/SmQRFW3/The-significance-of-on-time-delivery-in-ecommerce-00002.webp" className="w-full" />
    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide4" className="btn btn-circle">❮</a> 
      <a href="#slide2" className="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide2" className="carousel-item relative w-full">
    <img src="https://i.ibb.co/K291VvQ/istockphoto-1218607993-170667a.jpg" className="w-full" />
    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide1" className="btn btn-circle">❮</a> 
      <a href="#slide3" className="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide3" className="carousel-item relative w-full">
    <img src="https://i.ibb.co/G0tk0t3/pr-pre-employment-carpenter-600x400.jpg" className="w-full" />
    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide2" className="btn btn-circle">❮</a> 
      <a href="#slide4" className="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide4" className="carousel-item relative w-full">
    <img src="https://i.ibb.co/CKrFzH3/360-F-290705685-r14-NBlsy-Rp6-SHYm-H8l-UEv-Fqeizv-Xi-Og-P.jpg" className="w-full" />
    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide3" className="btn btn-circle">❮</a> 
      <a href="#slide1" className="btn btn-circle">❯</a>
    </div>
  </div>
</div>
            </div>
        </div>
    );
};

export default Services;